export const LICENSE_TIERS = [
	"Enterprise", //remove in future
	"Professional", //remove in future
	"Essential", //remove in future
	"enterprise",
	"professional",
	"essential",
	"basic",
] as const;
export type LicenseTier = (typeof LICENSE_TIERS)[number];

export const PRODUCT_TIER_PROPERTIES = {
	DIMENSIONING: "dimensioningLicenseTier",
	REPORTING: "reportingLicenseTier",
} as const;

const TIER_HIERARCHY: Record<LicenseTier, number> = {
	Enterprise: 3, //remove in future
	Professional: 2, //remove in future
	Essential: 1, //remove in future
	enterprise: 3,
	professional: 2,
	essential: 1,
	basic: 1, // "basic" is equivalent to "essential"
};

const normalizeTier = (tier: string | undefined | null): string | undefined => {
	return tier?.trim().toLowerCase();
};

export const checkTierHierarchy = (requiredTier: LicenseTier, currentTier: string | undefined | null): boolean => {
	if (!currentTier) return false;

	const normalizedRequiredTier = normalizeTier(requiredTier);
	const normalizedCurrentTier = normalizeTier(currentTier);

	if (!normalizedRequiredTier || !normalizedCurrentTier) return false;

	if (!(normalizedCurrentTier in TIER_HIERARCHY)) return false;

	const requiredLevel = TIER_HIERARCHY[normalizedRequiredTier as LicenseTier];
	const currentLevel = TIER_HIERARCHY[normalizedCurrentTier as LicenseTier | "basic"];

	if (requiredLevel === undefined || currentLevel === undefined) return false;

	return currentLevel >= requiredLevel;
};

/**
 * Check if currentTier meets or exceeds requiredTier.
 * Handles any tier name (enterprise, professional, essential, basic) case-insensitively.
 * Returns true if requiredTier is undefined/null.
 */
export const hasRequiredTier = (
	requiredTier: string | null | undefined,
	currentTier: string | null | undefined,
): boolean => {
	const normalizedRequiredTier = normalizeTier(requiredTier);
	if (!normalizedRequiredTier) {
		return true;
	}

	const normalizedCurrentTier = normalizeTier(currentTier);
	if (!normalizedCurrentTier) {
		return false;
	}

	const requiredLevel = TIER_HIERARCHY[normalizedRequiredTier as LicenseTier | "basic"];
	const currentLevel = TIER_HIERARCHY[normalizedCurrentTier as LicenseTier | "basic"];

	if (requiredLevel === undefined || currentLevel === undefined) {
		return false;
	}

	return currentLevel >= requiredLevel;
};

/**
 * Check if tier is Professional or higher (excludes Essential/Basic).
 */
export const isTierProfessionalOrHigher = (tier?: string | null): boolean => {
	const normalizedTier = normalizeTier(tier);
	return normalizedTier === "enterprise" || normalizedTier === "professional";
};
